var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectedPlan)?_c('RoutePlanElementEdit',{attrs:{"plan":_vm.selectedPlan},on:{"successSave":_vm.success,"back":_vm.success}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }